const transformOption = (o) => ({
  label: o,
  value: o,
});

export default transformOption;
